import Axios from '../axios-instance';

const MerchandiseRemittanceAPI = {
  getMerchandiseRemittance: body => {
    return Axios.post(`/DispatchNotes/Get`, body).then(({ data }) => data);
  },
  getFile: file => {
    return Axios.get(`/DispatchNotes/GetFile/${file}`).then(({ data }) => data);
  },
};

export default MerchandiseRemittanceAPI;
